import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { withContainerBox } from "../../hoc/withContainerBox";
import { ResponsiveBox, HGrid } from "../../primitives";
const CommonContainerBox = (props) => {
  const { t } = useTranslation();
  const fiName = localStorage.getItem("fiName");
  return (
    <ResponsiveBox
      maxWidth="100%"
      sx={{
        marginTop: `${props.marginTop}`,
        padding: `${props.padding}`,
        minHeight: `${props.minHeight}`,
      }}
    >
      <Helmet>
        <title>
          {fiName === "bmo"
            ? `${t(
                "erps.app.title.message.bmo",
                "Merchant Bill Pay Service"
              )}-${props.title}`
            : `${t(
                "erps.app.title.message",
                "Bill payment remittance reporting"
              )}-${props.title}`}
        </title>
      </Helmet>
      <HGrid container>{props.children}</HGrid>
    </ResponsiveBox>
  );
};

export default withContainerBox(CommonContainerBox);
